import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import analyticsService from "../../../services/analytics/analyticsService";
import EWallet from "../../../components/EWallet/EWallet";
import Header from "../../../components/Header/Header";
import useMakeWalletRefund from "../../../hooks/useMakeWalletRefund";
import eWalletInfo from "../../../interfaces/ewallet-info";
import validator from "../../../utils/validator";
import addCommas from "../../../utils/amountFormat";
import styles from "./EwalletRefundReview.module.scss";

function EwalletRefundReview() {
  const location = useLocation();
  const navigate = useNavigate();
  const [fullAmt, setFullAmt] = useState("true");
  const [partialAmt, setPartialAmt] = useState({
    value: "",
    touched: false,
    error: "",
  });
  const [makeWalletRefund] = useMakeWalletRefund();
  let dumble = new analyticsService();

  const {
    amount,
    grade,
    id,
    studentFirstName,
    studentLastName,
    teacherFirstName,
    teacherLastName,
  } = location.state as eWalletInfo;

  const { refundAmt, transactionId } = location.state as any;

  const item: eWalletInfo = {
    amount,
    grade,
    id,
    studentFirstName,
    studentLastName,
    teacherFirstName,
    teacherLastName,
  };

  const handleInput = (type: string, input: any, field: object) => {
    const newField: any = { ...field };
    newField[type] = input;
    return newField;
  };

  useEffect(() => {
    if (fullAmt === "true") {
      dumble.initDumblePage("Payment Portal:eWallet:Refund Review")
    }
    else {
      if (
        parseFloat(partialAmt.value.replaceAll(",", "")) > 0 &&
        parseFloat(partialAmt.value.replaceAll(",", "")) <= refundAmt.toFixed(2)
      ) {
        setPartialAmt(handleInput("error", "", partialAmt));
      } else {
        dumble.updateDumblePage("Payment Portal:eWallet:Refund Review Error");
        if (partialAmt.value.length !== 0){
          setPartialAmt(
            handleInput("error", "Invalid: Please enter valid amount", partialAmt)
          );
        }
        else{
          setPartialAmt(
            handleInput("error", validator(partialAmt.value, ["required"]), partialAmt)
          );
        }
      }
    }
    
  }, [fullAmt, partialAmt.value]);

  const displayError = (input: any) => {
    if (input.error !== "") {
      return <div className={styles.errorMessage}>{input.error}</div>;
    }
    return null;
  };

  const disableInput = () => {
    if (fullAmt === "" || fullAmt === "true") return true;
    return false;
  };

  const disableButton = () => {
    // "" means neither button is clicked
    // the second one means full refund isnt clicked and the value hasn't been inputed
    if (
      fullAmt === "" ||
      (fullAmt === "false" &&
        (partialAmt.value === "" || partialAmt.error !== ""))
    ) {
      return true;
    }
    return false;
  };

  const submitRefund = async (payload: any) => {
    const { data, error } = await makeWalletRefund(id, transactionId, payload);
    const partial = partialAmt.value === payload.amount;
    if (error) {
      console.log(error);
      if (error.status === 403) navigate("/");
    } else if (data != null) {
      dumble.setDumbleERefundCartInfo("Payment Portal:eWallet:Refund Confirmation", "eWallet Refund", payload.amount, partial, item.id.toString(), data.id);
      navigate("/success", { state: { toasterType: "refund" } });
    }
  };

  const eWalletRefundSuccess = () => {
    if (!disableButton()) {
      let transactionAmt;
      if (fullAmt === "true") transactionAmt = refundAmt;
      else {
        setPartialAmt(handleInput("touched", true, partialAmt));
        transactionAmt = parseFloat(partialAmt.value.replaceAll(",", ""));
      }
      const refundInfo = {
        amount: transactionAmt,
        message: "refund",

      };
      submitRefund(refundInfo);
    } 

  };

  return (
    <div
      className={styles.EwalletRefundReview}
      data-testid="EwalletRefundReview"
    >
      <Header
        name="Choose Refund Amount"
        redirect="/ewalletrefund/sales.html"
        state={{
          amount,
          grade,
          id,
          studentFirstName,
          studentLastName,
          teacherFirstName,
          teacherLastName,
        }}
      />
      <div className={styles.EwalletWrapper}>
        <div className={styles.responsive}>
          <div className={styles.ewallet}>
            <EWallet item={item} payment={false} />
          </div>
          <div className={styles.refundWrapper}>
            <h3>Choose Refund Amount</h3>
            <label htmlFor="fullRefund">
              <div className={styles.full}>
                  <input
                    checked={fullAmt=="true"}
                    type="radio"
                    name="refundButton"
                    value="Full Refund"
                    id="fullRefund"
                    onClick={() => {
                      dumble.updateDumblePage("Payment Portal:eWallet:Refund Review")
                      setPartialAmt(handleInput("touched", false, partialAmt));
                      setFullAmt("true");
                    }}
                  />
                  <div className={styles.fullRefund}>
                    <h4>Full Refund</h4>
                    <h4>{`$${refundAmt.toFixed(2)}`}</h4>
                  </div>
              </div>
            </label>
            <div className={styles.linebreak} />
            <label htmlFor="partialRefund">
              <input
                type="radio"
                name="refundButton"
                value="Partial Refund"
                id="partialRefund"
                onClick={() => {
                  
                  setFullAmt("false")}
                }
              />
              <h4>Partial Refund</h4>
            </label>
            <label htmlFor="partialAmount">
              <input
                type="text"
                className={styles.partialAmount}
                maxLength={10}
                id="partialAmount"
                disabled={disableInput()}
                value={`$ ${partialAmt.value}`}
                onBlur={() =>
                  setPartialAmt(handleInput("touched", true, partialAmt))
                }
                onChange={(e) =>
                  setPartialAmt(
                    handleInput(
                      "value",
                      addCommas(e.target.value),
                      partialAmt
                    )
                  )
                }
              />
            </label>
            {partialAmt.error !== "" && partialAmt.touched
              ? displayError(partialAmt)
              : null}
          </div>
        </div>
        <button
          type="submit"
          onClick={eWalletRefundSuccess}
          id="submitButton"
          disabled={false}
        >
          SUBMIT REFUND
        </button>
      </div>
    </div>
  );
}

export default EwalletRefundReview;
